import styled, { css } from 'styled-components';

/**
 * Override Nemo global styling
 * Issue: https://github.com/audi/audi-ui-react/issues/1199
 */
//
const Focus = css`
  *:focus {
    outline: revert;
  }
`;

const Checkbox = css`
  input[type='checkbox'] {
    height: 24px;
  }
`;

const SearchInput = css`
  input[type='search'] {
    height: unset;
  }
`;

export const GlobalStyleReset = styled.div<{ headerMobileView?: boolean; oneHeader?: boolean }>`
  ${Focus}
  ${Checkbox}
  ${SearchInput}

  height:${({ oneHeader, headerMobileView }) => (oneHeader && headerMobileView ? '100vh' : '100%')};
`;
